import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import { logoutUser } from '../../store/slices/authSlice'; // your logout action

const MainLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error } = useSelector((state) => state.auth); // assuming auth state stores token errors

  useEffect(() => {
    if (typeof error === 'string' && error.toLowerCase().includes('unauthenticated')) {
      Swal.fire({
        title: 'Session Expired',
        text: 'You are unauthenticated. Please log in again.',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        dispatch(logoutUser()); // remove token & user info
        navigate('/login'); // redirect to login
      });
    }
  }, [error, dispatch, navigate]);
  
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page">
          <Header />
          <div className="content-wrapper">
            <div className="container-fluid flex-grow-1 container-p-y">
              {children}
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default MainLayout;
